<template>
    <div>
        <div class="internal-container" >
            <div class="row pageFilters"> <!--page filter-->
                <div class="col-sm-12 col-md-3 customTab">
                    <div class="row">
                        <button id="" type="button" class="btnAttachment ml-2 btn btn-outline-primary pull-left"  v-on:click.prevent="backToMainList">Back</button>
                    </div>
                </div>

                <div class="col-sm-12 col-md-2 serch-attachment-tab">
                    <input type="text" class="form-control" id="attachmentSearchInGroupChild" placeholder="Search Attachments" v-model="attachmentSearch" name="attachmentSearch" />
                </div>

                <div class="col-sm-6 col-md-5 sortByField">
                    <label>Sort By:</label>
                    <v-select class="input-field-si" v-model="attachmentSort"
                              name="attachmentSort"
                              placeholder="Select field for sorting"
                              label="text"
                              :options="attachmentSortArr"
                              :clearable=false>
                    </v-select>
                </div>
                <div class="col-sm-12 col-md-2">
                    <button v-if="is_Grid_Child == true" class="btn pull-right" v-on:click.prevent="gridChange('single')"><img src="/static/images/listview-icon2.png"></button>
                    <button v-if="is_Grid_Child == false"  class="btn pull-right" v-on:click.prevent="gridChange('single')"><img src="/static/images/listview-icon1.png"></button>
                    <button v-if="is_Grid_Child == false" class="btn pull-right" v-on:click.prevent="gridChange('multiple')"><img src="/static/images/gridview-icon2.png"></button>
                    <button v-if="is_Grid_Child == true" class="btn pull-right" v-on:click.prevent="gridChange('multiple')"><img src="/static/images/gridview-icon1.png"></button>
                </div>
            </div>
        </div>
        <div class="internal-container">
            <!--<div class="internal-listing-container">
                    <template v-if="attachmentDataOfGroupChild.group_name >= 38">
                        <span :title="attachmentDataOfGroupChild.group_name">{{stringTrim(attachmentDataOfGroupChild.group_name,42)}}</span>
                    </template>
                    <template v-else>
                        <span>{{attachmentDataOfGroupChild.group_name}}</span>
                    </template>
            </div>-->
            <span class="ath-group-name">{{attachmentDataOfGroupChild.group_name}}</span>
            <div id="attachemntData">
                <template v-if="attachmentDataOfGroupChild.total_rows > 0">
                    <div class="internal-listing-container">
                        <template v-if="is_Grid_Child">
                            <template v-for="(data, index) in attachmentDataOfGroupChild.attachments">
                                <div class="single-listing">
                                    <div class="upload-doc-img">
                                        <template v-if="data.upload_type == 'url'">
                                            <img src="/static/images/link-icon.webp" class="link-icon">
                                        </template>
                                        <template v-else>
                                            <template v-if="data.documents.length > 0">
                                                <template v-for="(doc, index1) in data.documents">
                                                    <template v-if="doc.doc_extension.toLowerCase() == 'gif' || doc.doc_extension.toLowerCase() == 'jpg' || doc.doc_extension.toLowerCase() == 'jpeg' || doc.doc_extension.toLowerCase() == 'png'">
                                                        <img :src="doc.document">
                                                    </template>
                                                    <template v-else-if="doc.doc_extension.toLowerCase() == 'doc' || doc.doc_extension.toLowerCase() == 'docx'">
                                                        <img src="/static/images/doc-icon.webp" class="link-icon">
                                                    </template>
                                                    <template v-else-if="doc.doc_extension.toLowerCase() == 'xls' || doc.doc_extension.toLowerCase() == 'xlsx'">
                                                        <img src="/static/images/xl-icon.webp" class="link-icon">
                                                    </template>
                                                    <template v-else-if="doc.doc_extension.toLowerCase() == 'ppt' || doc.doc_extension.toLowerCase() == 'pptx'">
                                                        <img src="/static/images/ppt-icon.webp" class="link-icon">
                                                    </template>
                                                    <template v-else-if="doc.doc_extension.toLowerCase() == 'pdf'">
                                                        <img src="/static/images/pdf-icon.webp" class="link-icon">
                                                    </template>
                                                    <template v-else>
                                                        <img src="/static/images/link-icon.webp" class="link-icon">
                                                    </template>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <img src="/static/images/link-icon.webp" class="link-icon">
                                            </template>
                                        </template>
                                    </div>
                                    <div class="single-listing-text">
                                        <template v-if="data.upload_type == 'url'">
                                            <a :href="data.url" v-b-tooltip.hover :title="data.title" target="_blank">{{stringTrim(data.title,60)}}</a>
                                        </template>
                                        <template v-else>
                                            <span v-b-tooltip.hover :title="data.title">{{stringTrim(data.title,60)}}</span>
                                        </template>
                                    </div>
                                    <template v-if="data.upload_type != 'url'">
                                        <div class="download">
                                            <template v-for="(doc, index1) in data.documents">
                                                <a href="javascript:void(0)" @click="getSignedUrlPath(doc.document_path)">Download</a>
                                                <!-- <template v-if="data.pin">
                                                    <i class="fa fa-thumb-tack ml-2" title="Pinned" style="color: #c3202b" aria-hidden="true"></i>
                                                </template> -->
                                            </template>
                                        </div>
                                    </template>
                                    <div class="listing-user-info">
                                        <div v-if="user_role == 1">
                                            <b-navbar>
                                                <b-navbar-nav>
                                                    <b-nav-item-dropdown>
                                                        <router-link class="btn btn-primary pull-right" v-bind:to="{name: 'AttachmentEditForm', params:{id:data.id}}"><!--<i class="fa fa-pencil" aria-hidden="true"></i>-->Edit</router-link>
                                                        <button class="btn btn-primary pull-right" v-on:click.prevent="deleteDiscussion(data.id, 'attachment')"><!--<i class="fa fa-trash-o"></i>-->Delete</button>
                                                        <!-- <button v-if="data.pin" class="btn btn-primary pull-right" v-on:click.prevent="pinUnpinDiscussion(data.id, 'attachment', 'Unpin')">Unpin</button>
                                                        <button v-else class="btn btn-primary pull-right" v-on:click.prevent="pinUnpinDiscussion(data.id, 'attachment', 'Pin')">Pin</button> -->
                                                        <!-- <b-dropdown-item href="#">Settings</b-dropdown-item> -->
                                                    </b-nav-item-dropdown>
                                                </b-navbar-nav>
                                            </b-navbar>
                                        </div>
                                        <div class="listing-user">{{formatString(data.updated_name)}}</div>
                                        <div class="listing-block-info">
                                            <div class="listing-date">{{utcToLocal(data.updated_at,'MM/DD/YYYY')}}</div>
                                            <div class="listing-time">{{utcToLocal(data.updated_at,'hh:mm A')}}</div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                        <template v-else>
                            <div class="three-column-listing">
                                <div class="row">
                                    <template v-for="(data, index) in attachmentDataOfGroupChild.attachments">
                                        <div class="col-lg-4">
                                            <div v-bind:key="index" class="three-column-listing-block">
                                                <div class="upload-doc-img">
                                                    <template v-if="data.upload_type == 'url'">
                                                        <img src="/static/images/link-icon.webp">
                                                    </template>
                                                    <template v-else>
                                                        <template v-for="(doc, index1) in data.documents">
                                                            <div v-bind:key="index1">
                                                                <template v-if="doc.doc_extension.toLowerCase() == 'gif' || doc.doc_extension.toLowerCase() == 'jpg' || doc.doc_extension.toLowerCase() == 'jpeg' || doc.doc_extension.toLowerCase() == 'png'">
                                                                    <img :src="doc.document">
                                                                </template>
                                                                <template v-else-if="doc.doc_extension.toLowerCase() == 'doc' || doc.doc_extension.toLowerCase() == 'docx'">
                                                                    <img src="/static/images/doc-icon.webp">
                                                                </template>
                                                                <template v-else-if="doc.doc_extension.toLowerCase() == 'xls' || doc.doc_extension.toLowerCase() == 'xlsx'">
                                                                    <img src="/static/images/xl-icon.webp">
                                                                </template>
                                                                <template v-else-if="doc.doc_extension.toLowerCase() == 'ppt' || doc.doc_extension.toLowerCase() == 'pptx'">
                                                                    <img src="/static/images/ppt-icon.webp">
                                                                </template>
                                                                <template v-else-if="doc.doc_extension.toLowerCase() == 'pdf'">
                                                                    <img src="/static/images/pdf-icon.webp">
                                                                </template>
                                                                <template v-else>
                                                                    <img src="/static/images/link-icon.webp">
                                                                </template>
                                                            </div>
                                                        </template>
                                                    </template>
                                                </div>
                                                <div class="three-column-right">
                                                    <div class="three-column-right-container">
                                                        <div v-if="user_role == 1">
                                                            <b-navbar>
                                                                <b-navbar-nav>
                                                                    <b-nav-item-dropdown>
                                                                        <router-link class="btn btn-primary pull-right" v-bind:to="{name: 'AttachmentEditForm', params:{id:data.id}}"><!--<i class="fa fa-pencil" aria-hidden="true"></i>-->Edit</router-link>
                                                                        <button class="btn btn-primary pull-right" v-on:click.prevent="deleteDiscussion(data.id, 'attachment')"><!--<i class="fa fa-trash-o"></i>-->Delete</button>
                                                                        <!-- <b-dropdown-item href="#">Settings</b-dropdown-item> -->
                                                                    </b-nav-item-dropdown>
                                                                </b-navbar-nav>
                                                            </b-navbar>
                                                        </div>
                                                        <div class="three-column-right">
                                                            <div class="three-column-right-container">
                                                                <div v-if="user_role == 1">
                                                                    <b-navbar>
                                                                        <b-navbar-nav>
                                                                            <b-nav-item-dropdown>
                                                                                <router-link class="btn btn-primary pull-right" v-bind:to="{name: 'AttachmentEditForm', params:{id:data.id}}"><!--<i class="fa fa-pencil" aria-hidden="true"></i>-->Edit</router-link>
                                                                                <button class="btn btn-primary pull-right" v-on:click.prevent="deleteDiscussion(data.id, 'attachment')"><!--<i class="fa fa-trash-o"></i>-->Delete</button>
                                                                                <!-- <b-dropdown-item href="#">Settings</b-dropdown-item> -->
                                                                            </b-nav-item-dropdown>
                                                                        </b-navbar-nav>
                                                                    </b-navbar>
                                                                </div>
                                                                <span>
                                                                    <template v-if="data.upload_type == 'url'">
                                                                        <!-- <a :href="data.url" target="_blank" v-b-tooltip.hover :title="data.title">{{stringTrim(data.title,20)}}</a> -->
                                                                        <span v-if="data.title.length <= 20" v-b-tooltip.hover.topright :title="data.title">{{stringTrim(data.title,20)}}</span>
                                                                        <span v-else v-b-tooltip.hover.topright :title="data.title">{{stringTrim(data.title,20)}}</span>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span v-if="data.title.length <= 20" v-b-tooltip.hover.topright :title="data.title">{{stringTrim(data.title,20)}}</span>
                                                                        <span v-else v-b-tooltip.hover.topright :title="data.title">{{stringTrim(data.title,20)}}</span>
                                                                    </template>
                                                                </span>
                                                                <div class="listing-block-info">

                                                                    <div class="listing-date">{{utcToLocal(data.updated_at,'MM/DD/YYYY')}}</div>
                                                                    <div class="listing-time">{{utcToLocal(data.updated_at,'hh:mm A')}}</div>
                                                                </div>
                                                            </div>
                                                            <template v-if="data.upload_type != 'url'">
                                                                <template v-for="(doc, index1) in data.documents">
                                                                    <a v-bind:key="index1" href="javascript:void(0)" @click="getSignedUrlPath(doc.document_path)">Download Now!</a>
                                                                </template>
                                                            </template>
                                                            <template v-else>
                                                                <a :href="data.url" class="downloadnow" target="_blank">Visit Now!</a>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </template>

                        <div v-if="attachmentDataOfGroupChild.total_rows >= attachmentDataOfGroupChild.per_page">
                            <b-pagination align="center"
                                          prev-text="‹ Previous"
                                          next-text="Next ›" :total-rows="attachmentDataOfGroupChild.total_rows" v-model="attachmentCurrentPage" :per-page="attachmentDataOfGroupChild.per_page"></b-pagination>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="">
                        <div class="forms-container">
                            <div class="error-template">
                                <div class="error-details no-data-found-error">
                                    No attachments found...!!!
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import vSelect from 'vue-select';
    import {commonMixins} from '../mixins/commonMixins';
    import {HTTP} from '../http-common.js';
    import { swiper, swiperSlide } from 'vue-awesome-swiper';
    export default {
        components: {
            'v-select': vSelect,
            swiper,
            swiperSlide,
        },
        props: ['attachmentDataOfGroupChild','is_Grid_Child','backButtonClicked','loadAttachmentFrom','menuSlug','selected_group_id'],
        mixins: [commonMixins],
        data() {
            return {
                attachmentSearch:"",
                attachmentSortArr: [{
                    text: 'Newest First',
                    value: 'desc'
                },
                    {
                        text: 'Oldest First',
                        value: 'asc'
                }],
                attachmentSort: {text: "Newest First", value: 'desc'},
                attachmentCurrentPage: 1,
            }
        },
        computed: {
        },
        watch: {
            attachmentCurrentPage: function () {
                var self = this;
                self.loadSalesAttachment();
            },
            attachmentSort: function () {
                var self = this;
                self.loadSalesAttachment();
            },
        },
        mounted: function () {
            var self = this;
            $("#attachmentSearchInGroupChild").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    self.loadSalesAttachment();
                }
            });
        },
        methods: {
            backToMainList: function () {
                var self = this;
                self.backButtonClicked();
            },
            clickAttachmentReLoad: function () {
                var self = this;
                self.loadAttachmentFrom();

            },
            gridChange: function (gridFlag) {

                var self = this;
                if (gridFlag != "single") {
                    self.is_Grid_Child = false;
                } else {
                    self.is_Grid_Child = true;
                }
            },
            stringTrim: function (string, length) {
                length = (typeof length !== 'undefined') ? length : 20;
                var string1 = (string.length > length) ? string.substring(0, length) + '...' : string;
                return string1;
            },
            formatString: function (data) {
                data = (data === null || typeof data === "undefined") ? '' : data;
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            utcToLocal: function (dateTime, format) {
                var self = this;
                var local = moment.utc(dateTime).local().format(format);
                return local;
            },
            /* Display Sales Post End*/
            /* Display Sales Attachments Start*/
            loadSalesAttachment: function () {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    params: {
                        'slug': self.menuSlug,
                        'page': self.attachmentCurrentPage,
                        'filter': self.attachmentSearch,
                        'sort': self.attachmentSort.value,
                    }
                };
                self.showLoader();
                HTTP.get("display_sales_attachment/"+self.selected_group_id, config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            self.attachmentDataOfGroupChild = response.data.content;
                            if (response.data.content.length <= 0) {
                                self.attachmentCurrentPage = 1;
                            }
                        }
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        self.hideLoader();
                        self.catchHandler(err, function () {});
                    });
            },
            pinUnpinDiscussion: function(salesId, pinFlag, type) {
                var self = this;
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("tkn")
                    }
                };
                var fields = {
                    'salesId': salesId,
                    'salest_type': pinFlag,
                    'type': type
                };
                self.$swal({
                    title: 'Are you sure?',
                    text: 'You want to ' + type + ' ' + pinFlag + ' ?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Change it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.showLoader();
                        HTTP.post("pin/unpin/salesdata", fields, config)
                            .then(function (response) {
                                if (response.data.code == '200') {
                                    self.$swal({
                                        title: self.formatString(pinFlag) + " " + type + " successfully",
                                        text: "",
                                        type: "success",
                                    });
                                    self.clickAttachmentReLoad();
                                    self.loadSalesAttachment();
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.hideLoader();
                                self.catchHandler(err, function () {});
                            });
                    }
                });
            },
            deleteDiscussion: function (salesId, deleteFlag) {
                var self = this;
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("tkn")
                    },
                    data: {
                        'salesId': salesId,
                        'salest_type': deleteFlag
                    }
                };
                self.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.showLoader();
                        HTTP.delete("delete_sales_data", config)
                                .then(function (response) {
                                    if (response.data.code == '200') {
                                        self.clickAttachmentReLoad();
                                        self.loadSalesAttachment();
                                        self.$swal({
                                            title: self.formatString(deleteFlag) + " Delete successfully",
                                            text: "",
                                            type: "success",
                                        });
                                    }
                                    self.hideLoader();
                                })
                                .catch(function (err) {
                                    self.hideLoader();
                                    self.catchHandler(err, function () {});
                                });
                    }
                });
            },
        }
    }
</script>